import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IncidentRegelSetStatus } from '../models/IncidentRegelSetStatus';
import { Regel } from '../models/Regel';
import { RegelSet } from '../models/RegelSet';
import { RegelSetActie } from '../models/RegelSetActie';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class RegelsService {
  constructor(
    private http: HttpClient,
    private appConfigSvc: AppConfigService
  ) {}

  loadRegelSets() {
    return this.http.get<RegelSet[]>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSet'
    );
  }

  loadRegelSet(regelSetId) {
    return this.http.get<RegelSet>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSet/' + regelSetId
    );
  }

  saveRegelSet(regelSet: RegelSet) {
    if (regelSet.regelSetId) {
      return this.http.put<RegelSet>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSet',
        regelSet
      );
    } else {
      return this.http.post<RegelSet>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSet',
        regelSet
      );
    }
  }

  deleteRegelSet(regelSetId) {
    return this.http.delete<RegelSet>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSet/' + regelSetId
    );
  }

  loadRegel(regelSetId: string) {
    return this.http.get<Regel[]>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/Regel/' + regelSetId
    );
  }

  saveRegel(regel: Regel) {
    if (regel.regelId) {
      return this.http.put<Regel>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/Regel',
        regel
      );
    } else {
      return this.http.post<Regel>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/Regel',
        regel
      );
    }
  }

  deleteRegel(regelId) {
    return this.http.delete<Regel>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/Regel/' + regelId
    );
  }

  loadRegelSetActie(regelSetId: string) {
    return this.http.get<RegelSetActie[]>(
      this.appConfigSvc.getConfig().apiRoot +
        '/Regels/RegelSetActies/' +
        regelSetId
    );
  }

  saveRegelSetActie(regelSetActie: RegelSetActie) {
    if (regelSetActie.regelSetActieId) {
      return this.http.put<RegelSetActie>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSetActie',
        regelSetActie
      );
    } else {
      return this.http.post<RegelSetActie>(
        this.appConfigSvc.getConfig().apiRoot + '/Regels/RegelSetActie',
        regelSetActie
      );
    }
  }

  deleteRegelSetActie(regelSetActieId) {
    return this.http.delete<RegelSetActie>(
      this.appConfigSvc.getConfig().apiRoot +
        '/Regels/RegelSetActie/' +
        regelSetActieId
    );
  }

  loadIncidentRegelSetStatus(van: Date, tot: Date) {
    let params = new HttpParams()
      .append('van', van.toISOString())
      .append('tot', tot.toISOString());
    return this.http.get<IncidentRegelSetStatus[]>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/IncidentRegelSetStatus',
      { params: params }
    );
  }

  loadIncidentRegelSetStatusByIncidentNummer(
    incidentNummer,
    van: Date,
    tot: Date
  ) {
    let params = new HttpParams()
      .append('van', van.toISOString())
      .append('tot', tot.toISOString());

    return this.http.get<IncidentRegelSetStatus[]>(
      this.appConfigSvc.getConfig().apiRoot +
        '/Regels/IncidentRegelSetStatus/' +
        incidentNummer,
      { params: params }
    );
  }

  beschikbareRegelTypes() {
    return this.http.get<string[]>(
      this.appConfigSvc.getConfig().apiRoot + '/Regels/BeschikbareRegelTypes'
    );
  }

  beschikbareRegelSetActieTypes() {
    return this.http.get<string[]>(
      this.appConfigSvc.getConfig().apiRoot +
        '/Regels/BeschikbareRegelSetActieTypes'
    );
  }
}
